import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { AdminOrganization } from '../types/admin/admin-organization';
import { Org, ReturnOrgRequest } from '../types/org';
import { OrgControlValues } from '../types/org-control-values';
import { User } from '../types/user';

@Injectable({
  providedIn: 'root'
})
export class OrgManagementService {
  private readonly orgMessenger = new Subject<void>();

  constructor(private readonly http: HttpClient, @Inject('BASE_URL') private readonly originUrl: string) { }

  pathOrgMaintenence = 'api/OrgMaintenance';

  public getUser(): Observable<User> {
    return this.http.get<User>(`${this.originUrl}api/user`);
  }

  public getOrgMaintenance(): Observable<AdminOrganization[]> { // only those with dropdown type "Organization"
    return this.http.get<AdminOrganization[]>(`${this.originUrl}${this.pathOrgMaintenence}`);
  }

  public getControlValues(): Observable<OrgControlValues> {
    return this.http.get<OrgControlValues>(`${this.originUrl}${this.pathOrgMaintenence}/ControlValues`);
  }

  public getSpecificOrg(orgNumber: number): Observable<Org> {
    return this.http.get<Org>(`${this.originUrl}${this.pathOrgMaintenence}/${orgNumber}`);
  }

  // GM.FAS5_PG\GM.FAS5.API\Endpoint\Admin\OrgMaintenance\OrgMaintenanceController.cs
  // has the endpoint information required
  // additional checks required

  public saveChanges(org: Org): Observable<Org> {
    return this.http.put<Org>(`${this.originUrl}${this.pathOrgMaintenence}`, org);
  }
  
  public createOrg(org: Org): Observable<Object> {
    return this.http.post<Object>(`${this.originUrl}${this.pathOrgMaintenence}`, org);
  }

  public getNewOrgSubscription(): Observable<void> {
    return this.orgMessenger.asObservable();
  }

  public propagateOrg() {
    this.orgMessenger.next();
  }

  public returnItems(returnRequest: ReturnOrgRequest): Observable<boolean> {
    return this.http.post<boolean>(`${this.originUrl}${this.pathOrgMaintenence}/Return`, returnRequest);
  }

  public finalizeSelectedOrg(org: Org): Observable<boolean> {
    return this.http.post<boolean>(`${this.originUrl}${this.pathOrgMaintenence}/Finalize`, org);
  }

  public isOrgRetirable(orgNumber: number): Observable<boolean> {
    return this.http.get<boolean>(`${this.originUrl}${this.pathOrgMaintenence}/Retirable/${orgNumber}`);
  }
}
